import React from 'react';

import conquestToCapIntelLogo from '@/images/conquest-capintel.svg';

type Props = {
  title?: string;
  instructions?: string;
  hideText?: boolean;
};

const IntegrationPageHeader: React.FC<Props> = (props: Props) => {
  const { title, instructions, hideText } = props;

  const conquestToCapIntelImg = <img src={conquestToCapIntelLogo} width="394" height="24" className="page-header-logo" alt="Conquest CapIntel" />;

  return (
    <div className="page-header">
      {conquestToCapIntelImg}
      {!hideText && (
        <div className="page-header-text">
          {title && <h1>{title}</h1>}
          {instructions && <p className="instructions">{instructions}</p>}
        </div>
      )}
    </div>
  );
};

export default IntegrationPageHeader;
